var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('h1',[_vm._v("This is an Empty page "+_vm._s(_vm.componentName))])])}
var staticRenderFns = []

export { render, staticRenderFns }